<template>
  <div>
    <el-button type="primary" class="add-button" size="large" :disabled="inputs.length === max" @click="inputs.length < max && onAdd()">
      {{ addButtonTitle }}
    </el-button>
    <div v-for="(inputObj, i) in inputs" :key="`${i}-${inputObj.id}`">
      <Input
        :id="`${i}-${inputObj.id}`"
        :required="inputObj.required"
        :disabled="inputObj.disabled"
        :label="`${inputObj.label}-${i + 1}`"
        :value="inputValues[i]"
        :placeholder="inputObj.placeholder"
        :onChange="(value) => inputObj.onChange(value, i)"
        :type="inputObj.type"
      />
      <el-button
        v-if="inputs.length > 1 && i !== 0"
        color="#ff4949"
        class="remove-button"
        size="large"
        @click="inputs.length > 1 && onRemove(i)"
      >
        Delete
      </el-button>
    </div>
  </div>
</template>

<script>
import Input from '../../../Input.vue'
export default {
  components: {
    // eslint-disable-next-line vue/no-reserved-component-names
    Input,
  },
  props: {
    addButtonTitle: {
      type: String,
      default: 'Add',
    },
    max: {
      type: Number,
      default: 3,
    },
    input: {
      type: Object,
      required: true,
    },
    inputValues: {
      type: Array,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: [],
    },
    inputs: {
      type: Array,
      required: true,
    },
    onAdd: {
      type: Function,
      required: true,
    },
    onRemove: {
      type: Function,
      required: true,
    },
  },
  mounted() {
    // If inputs array is empty add one new input
    this.inputs.length === 0 && this.onAdd()
  },
}
</script>

<style scoped>
.add-button,
.remove-button {
  float: right;
}
.remove-button {
  margin-top: 0.3rem;
  color: white;
}
.remove-button:hover {
  color: white;
}
</style>
